import React from "react";
import styles from "../resourceMonitoring/ResourceMonitor.module.scss";
import { CalendarIconDate, NotFoundIcon } from "../../../modules/default-svg";
import Spin from "../../../components/controls/spinner/Spin";
import NotFoundLayout from "../../../components/controls/NotFound/NotFound";
import { Tooltip } from "@fluentui/react-components";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const AssignedTasksCard = ({ isLoading, tasks }) => {
  const history = useHistory();

  const getPriorityPill = (priority) => {
    switch (priority) {
      case 0:
        return "pill success";
      case 1:
        return "pill orange";
      case 2:
        return "pill warning";
      case 3:
        return "pill orange";
      default:
        return "";
    }
  };

  const getPriority = (priority) => {
    switch (priority) {
      case 0:
        return "Low";
      case 1:
        return "Moderate";
      case 2:
        return "High";
      case 3:
        return "Urgent";
      default:
        return "";
    }
  };

  return (
    <div
      className={styles.TaskCardContainer}
      style={{ height: tasks.length === 0 ? 460 : 560 }}
    >
      <div
        className={
          tasks.length > 0
            ? styles.CalendarModalScroll
            : styles.verticallyCenteredContainer
        }
      >
        {isLoading ? (
          <div className={styles.spinnerContainer}>
            <Spin />
          </div>
        ) : (
          <div
            className={`row ${styles.cardBody}`}
            style={{ "--bs-gutter-x": "12px", "--bs-gutter-y": "16px" }}
          >
            {Array.isArray(tasks) && tasks.length > 0 ? (
              tasks?.map((item) => (
                <div className="col-6">
                  <div
                    className={`${styles.cardTask} ${
                      item.status < 2 ? styles.cardWhite : styles.cardRed
                    }`}
                    style={{ cursor: item?.scope?.id ? "pointer" : "default" }}
                    onClick={() =>
                      item?.scope?.id
                        ? history.push(
                            `/scopes/${item.scope.id}/overview?taskId=${item.id}`
                          )
                        : null
                    }
                  >
                    <div className="d-flex align-items-start mb-12 justify-content-between">
                      <div>
                        <div className="d-flex align-items-center mb-1">
                          {item.refId && (
                            <span className="text-xxsm-400 grey36Color">
                              {item.refId} ·&nbsp;
                            </span>
                          )}
                          <span className="text-xxsm-400 grey36Color">
                            Planning
                          </span>
                        </div>
                        <p className="text-sm-400 heading-color">{item.name}</p>
                      </div>
                      <Tooltip
                        content="Capacity: 100% Utilized"
                        relationship="label"
                        withArrow
                        positioning="after"
                      >
                        <div className="CapacityWeekly">
                          {item.allocatedEffort} hrs
                        </div>
                      </Tooltip>
                    </div>

                    <div className={`${styles.statPills} d-flex mb-3`}>
                      <span className={getPriorityPill(item.status)}>
                        {getPriority(item.status)}
                      </span>

                      {item?.startDate && item?.endDate && (
                        <div className="d-flex align-items-center">
                          <CalendarIconDate />

                          <p className="text-xxsm-400 ms-1">
                            <span className={`${styles.startDatetext}`}>
                              {item.startDate
                                .split("T")[0]
                                .split("-")
                                .join("/")}
                            </span>{" "}
                            -{" "}
                            <span className={`${styles.startDatetext}`}>
                              {item.endDate.split("T")[0].split("-").join("/")}
                            </span>
                          </p>
                        </div>
                      )}
                    </div>

                    {/* <div className="d-flex flex-wrap align-items-center gap-2">
                      {(item.allocations.length > 2
                        ? item.allocations.slice(0, 2)
                        : item.allocations
                      ).map((data) => (
                        <div className="AssignToChip large">
                          <Avatar
                            color="colorful"
                            size={32}
                            img={{ src: data.resource.image }}
                            name={data.resource.name}
                          />
                          <div className="d-flex gap-2 justify-content-center align-items-center">
                            <p className="text-xsm-400">{data.resource.name}</p>
                            -
                            <span className="text-xsm-400">
                              {data.allocatedEffort}hrs
                            </span>
                          </div>
                        </div>
                      ))}

                      {item.allocations.length > 2 && (
                        <div className="CounterBadge">
                          +{item.allocations.length - 2}
                        </div>
                      )}
                    </div> */}
                  </div>
                </div>
              ))
            ) : (
              <NotFoundLayout
                icon={<NotFoundIcon />}
                heading="No data currently available!"
                para="Try searching for what you need or explore other features to get
        started."
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default AssignedTasksCard;
